<template>
  <div id="lista-nominal">
    <Menu />

    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Lista nominal"
            description=""
            url="/administracao/importar-dados"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao="https://doc.clickup.com/9011510980/d/h/8cj1fp4-1631/599ea88448ce3d9/8cj1fp4-9491"
            pageIdentifier="importar-dados-lista-nominal"
            :enableBadgeModalInformacao="
              Number(
                $store.state.permissoesRaw
                  ?.importar_dados_lista_nominal_ajuda || 0
              ) > 0
            "
            :badgeValueModalInformacao="
              $store.state.permissoesRaw?.importar_dados_lista_nominal_ajuda ||
              0
            "
            keyAjudaModalInformacao="importar_dados_lista_nominal_ajuda"
          />
        </div>

        <div
          v-for="indicador in indicadores"
          :key="indicador.id"
          class="col-md-12"
        >
          <ImportadorListaNominal :indicador="indicador" />
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import ImportadorListaNominal from './components/ImportadorListaNominal.vue'
import { indicadores } from './config/indicadores'

export default {
  metaInfo: {
    title: 'Lista nominal',
    titleTemplate: null,
  },

  components: {
    Menu,
    Footer,
    SectionTitle,
    ImportadorListaNominal,
  },

  data() {
    return {
      indicadores,
    }
  },
}
</script>

<style lang="scss" scoped>
#lista-nominal {
  .table-responsive {
    display: inherit;
    margin-bottom: 0px;
  }
}
</style>
